import React from 'react';
import styles from './admin.module.css';

const Admin = () => {

    const logsButtonClick = () => {
        window.location.href = '/admin/logs';
    }
    const sendEmailClick = () => {
        window.location.href = '/admin/email';
    }

    return (
        <>
        <div className={styles.adminPage}>
            <h2>Admin Dashboard</h2>
            <div className={styles.adminContainer}>
                <button className={styles.logsButton} onClick={logsButtonClick}>
                    View Logs
                </button>
                <button className={styles.sendEmailButton} onClick={sendEmailClick}>
                    Send Email
                </button>
            </div>
        </div>
        </>
    );
}

export default Admin;